import { getBrowserName } from '../device'

const PLATFORM = 'web'

const {
  navigator: {
    userAgent,
    platform,
  },
  location: {
    hostname,
    protocol,
  },
  devicePixelRatio,
} = window

export default function createQoSDataStore({
  defaultStateParams,
  getPlayerState,
}) {
  const deviceBrowser = getBrowserName()

  const defaultQosState = {
    // platform
    appPlatform: PLATFORM,
    appOrigin: `${protocol}//${hostname}`,
    // user params
    devicePlatform: platform,
    deviceBrowser,
    deviceUserAgent: userAgent,
    deviceScreenDimensions: window.screen
      ? `${window.screen.width}x${window.screen.height}`
      : 'no data available',
    devicePixelRatio,
    ...defaultStateParams,
  }

  let qosState = defaultQosState

  const setQosState = (update) => {
    qosState = {
      ...qosState,
      ...update,
    }
  }

  const getQosState = () => ({
    ...qosState,
    ...getPlayerState(),
  })

  return {
    setQosState,
    reset: () => {
      qosState = defaultQosState
      return getQosState()
    },
    getQosState,
  }
}
